import React from 'react';
import { useTranslation } from 'react-i18next';
import api from '../utils/api';
import { setLanguage, SUPPORTED_LANGUAGES } from '../i18n';
import { markGuestLanguageChoice } from '../utils/languageOverride';

// Public language choice in the header. Guests only store it locally (no API call). A signed-in user's
// choice is also saved to the profile, so the Profile row and this select always show the same language.
export default function LanguageSelect() {
  const { t, i18n } = useTranslation();

  const change = async (code) => {
    setLanguage(code);
    // A guest's explicit choice survives logout and wins at the next login
    if (!localStorage.getItem('token')) {
      markGuestLanguageChoice(code);
      return;
    }
    try {
      await api.patch('/api/users/me', { language: code });
      const stored = JSON.parse(localStorage.getItem('user') || 'null');
      if (stored) localStorage.setItem('user', JSON.stringify({ ...stored, language: code }));
    } catch (err) {
      // The local choice still applies; the profile can be saved again from Edit Profile
      console.error('Could not save language to profile', err);
    }
  };

  return (
    <div className="relative shrink-0 flex items-center">
      <i className="fas fa-globe absolute left-2 text-gray-300 pointer-events-none text-sm" aria-hidden="true" />
      <select
        aria-label={t('profile.language')}
        value={i18n.language}
        onChange={(e) => change(e.target.value)}
        className="appearance-none text-left bg-gray-700 text-white text-xs sm:text-sm font-medium rounded-md border border-gray-600 pl-6 pr-5 sm:pl-7 sm:pr-6 py-1.5 min-h-[44px] sm:min-h-0 cursor-pointer hover:bg-gray-600 hover:border-gray-500 focus:outline-none focus-visible:ring-2 focus-visible:ring-green-400 focus-visible:ring-offset-2 focus-visible:ring-offset-gray-800"
      >
        {SUPPORTED_LANGUAGES.map((l) => <option key={l.code} value={l.code}>{l.label}</option>)}
      </select>
    </div>
  );
}
